<template>
    <div class="card card-flush stream-box-home">
        <div class="card-body d-flex flex-column mt-9 pb-0">
            <h4 class="card-title">

            </h4>

            <div v-if="isLoadingStreams" class="text-center mt-3">
                <span class="spinner-border spinner-border-lg text-success"></span>
                <p>جاري تحميل البثوث...</p>
            </div>

            <div v-else-if="streams.length" class="row">
                <div v-for="stream in streams" :key="stream.class_id" class="col-md-12 mb-4">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <h5 class="card-title">{{ stream.title }}</h5>
                            <p>الدورة: {{ stream.course_title }}</p>

                            <div v-if="isLive(stream)">
                                <span class="badge badge-dark p-2">مباشر الآن</span>
                                <span class="badge badge-secondary text-dark m-1">ينتهي في {{ stream.live_ends_at
                                    }}</span>
                                <br>
                                <a class="btn btn-danger mt-3 btn-sm" @click="joinLiveStream($event, stream.class_id)">
                                    <i class="fa fa-arrow-right"></i> انضم الآن
                                </a>
                            </div>
                            <div v-else-if="isEnded(stream)">
                                <span class="badge badge-danger">انتهى البث</span>
                            </div>
                            <div v-else>
                                <span class="badge badge-success">يبدأ في {{ stream.live_starts_at }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="alert alert-secondary text-dark text-center">
                لا توجد بثوث مباشرة متاحة
            </div>
        </div>
    </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
    name: "DashboardView",
    data() {
        return {
            token: localStorage.getItem("access_token"),
            streams: [],
            isLoadingStreams: false
        };
    },
    mounted() {
        this.getsuggestLive();
    },
    methods: {
        async getsuggestLive() {
            this.isLoadingStreams = true;
            try {
                const response = await fetch(`${apiUrl}/livestream/get-similar-courses`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${this.token}`,
                        "Content-Type": "application/json",
                    },
                });

                if (response.ok) {
                    this.streams = await response.json();
                } else {
                    console.error("Failed to fetch live streams");
                }
            } catch (error) {
                console.error("Error fetching live streams:", error);
            } finally {
                this.isLoadingStreams = false;
            }
        },

        async joinLiveStream(event, id) {
            let button = event.target;

            let originalContent = button.innerHTML;

            button.innerHTML = `<span class="spinner-border spinner-border-sm"></span> جاري الانضمام...`;
            button.classList.add("disabled");
            try {
                const response = await fetch(`${apiUrl}/livestream/token/` + id, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.token}`,
                    },
                });

                let data = await response.json();

                if (data.token) {
                    window.open(`https://live.academia.ly/?token=${data.token}`, "_blank");
                } else {
                    alert("فشل في جلب التوكن، حاول مرة أخرى!");
                }
            } catch (error) {
                console.error("Error fetching token:", error);
                alert("حدث خطأ أثناء الاتصال بالخادم!");
            } finally {
                // إعادة محتوى الزر إلى حالته الأصلية
                button.innerHTML = originalContent;
                button.classList.remove("disabled");
            }
        },
        isLive(stream) {
            const now = new Date();
            return new Date(stream.live_starts_at) <= now && new Date(stream.live_ends_at) >= now;
        },
        isEnded(stream) {
            return new Date(stream.live_ends_at) < new Date();
        },
        formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleString("ar-EG", { dateStyle: "full", timeStyle: "short" });
        },
    },
};
</script>

<style scoped>
.card {
    border-radius: 10px;
}

.card-body {
    text-align: right;
}
</style>
